<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();
const { fetchUserProfile } = useUserData();

const {
  reportYear: currentYear,
  hasRequiredData,
  handleDownload,
} = useIrpfReport();

useSeo({
  title: t('income_report_external.title', { year: currentYear }),
});

// Minha Conta V2 (ENG-362): o informe de rendimentos vive em /user/irpf
// (UserV2ScreenIncomeReport) — com o flag ligado esta rota só redireciona.
// Atenção: condição INVERTIDA em relação a pages/user/data.vue (lá o
// redirect acontece com o flag desligado).
if (isUserV2Enabled.value) {
  await navigateTo(localeLink('/user/irpf'), { redirectCode: 302 });
}

onBeforeMount(() => {
  if (!hasRequiredData.value) {
    fetchUserProfile({ force: true });
  }
});
</script>

<template>
  <UserAccountPageLayout
    on-back="user-account"
    :title="$t('income_report_external.title', { year: currentYear })"
  >
    <UserBox>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <h2 class="text-base font-semibold text-texts">
            {{ $t('income_report_external.heading') }}
          </h2>
          <p class="text-sm text-texts/70">
            {{
              $t('income_report_external.description', { year: currentYear })
            }}
          </p>
        </div>

        <div class="flex flex-col gap-3 w-full max-w-[400px]">
          <div
            v-if="!hasRequiredData"
            class="flex flex-col gap-2 p-4 rounded-md bg-error/10 border border-error/20"
          >
            <p class="text-sm text-error font-medium">
              {{ $t('income_report_external.incomplete_data') }}
            </p>
          </div>

          <button
            class="py-3 px-4 rounded-md w-full text-sm flex items-center justify-center gap-2 bg-primary text-button-text font-bold disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="!hasRequiredData"
            @click="handleDownload"
          >
            <NuxtIcon
              filled
              name="document"
            />
            {{ $t('income_report_external.download_button') }}
          </button>
        </div>
      </div>
    </UserBox>
  </UserAccountPageLayout>
</template>
